import { render, staticRenderFns } from "./LayoutsMoodGlobeSection.vue?vue&type=template&id=3ae78bd4"
import script from "./LayoutsMoodGlobeSection.vue?vue&type=script&lang=ts"
export * from "./LayoutsMoodGlobeSection.vue?vue&type=script&lang=ts"
import style0 from "./LayoutsMoodGlobeSection.vue?vue&type=style&index=0&id=3ae78bd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports